import type { Locale } from '@/lib/i18n/config'

import { useI18n } from '@/lib/i18n/context'

// Entries are plain strings or small functions for interpolation and plurals
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Entry = string | ((...args: any[]) => string)

export type TextDict = Record<string, Entry>

/**
 * Declares the Spanish and English copy of one module side by side. The
 * English object must carry exactly the same keys and signatures.
 */
export const defineText = <T extends TextDict>(es: T, en: { [K in keyof T]: T[K] }): Record<Locale, T> => {
    return { 'es-mx': es, en: en as T }
}

export const useText = <T extends TextDict>(dict: Record<Locale, T>): T => {
    const { locale } = useI18n()

    return dict[locale]
}

/** Spanish and English plural helper: `plural(n, 'iniciativa', 'iniciativas')`. */
export const plural = (count: number, one: string, other: string): string => (Math.abs(count) === 1 ? one : other)
